module.exports = __webpack_public_path__ + "img/safe_06.04f86267.png";